import React from 'react'

import MediaAvatar from '../MediaAvatar'

import { useUserAPI } from '../../../providers/UserAPIProvider'
import useStyles from './style'

interface ArticleAvatarProps {
  userId: string
  onClick: () => void
  useDiv?: boolean
}

type CellProps = Pick<
  React.HTMLAttributes<HTMLDivElement>,
  'onClick' | 'children' | 'className'
> & {
  useDiv?: boolean
}

const Cell: React.FC<CellProps> = ({ useDiv, ...props }) => {
  if (useDiv) {
    return <div role='cell' {...props} />
  }

  return <td role='cell' {...props} />
}

const ArticleAvatar: React.FC<ArticleAvatarProps> = ({
  userId,
  onClick,
  useDiv
}) => {
  const { allUsers, loadUser } = useUserAPI()
  const isLoaded = !!allUsers[userId]
  const user = allUsers[userId]
  const noUser = !userId
  const classes = useStyles({ noUser: noUser })

  React.useEffect(() => {
    if (!allUsers[userId]) {
      loadUser(userId)
    }
  }, [allUsers, loadUser, userId])

  if (noUser) {
    return (
      <Cell useDiv={useDiv} onClick={onClick} className={classes.root}>
        {/* @ts-ignore */}
        <MediaAvatar user={null} className={classes.avatar} />
        <div className={classes.label}>No one</div>
      </Cell>
    )
  }

  return (
    <Cell useDiv={useDiv} onClick={onClick} className={classes.root}>
      {/* @ts-ignore */}
      <MediaAvatar user={user} className={classes.avatar} />
      <div className={classes.label}>
        {!isLoaded ? 'Loading...' : user?.name}
      </div>
    </Cell>
  )
}

export default ArticleAvatar
